import { UseQueryOptions } from '@tanstack/react-query';

import APIError from 'types/api_error';
import { CameraDiscoveryRequestResult } from 'types/camera_discovery_request';

import { useAPI } from 'hooks/api/useAPI';
import { useAuthenticatedQuery } from 'hooks/api/useAuthenticatedQuery';

type UseCameraDiscoveryRequestOptions = UseQueryOptions<
  CameraDiscoveryRequestResult,
  APIError
> & {
  params?: { unlinked_only: boolean };
};

export function useCameraDiscoveryRequest(
  gatewayId: string | null | undefined,
  requestId: string | null | undefined,
  {
    params = { unlinked_only: true },
    enabled,
    ...options
  }: UseCameraDiscoveryRequestOptions = {}
) {
  const { applicationID, client } = useAPI();

  return useAuthenticatedQuery(
    ['camera-discovery-request', gatewayId, requestId],
    async () => {
      if (!requestId || !gatewayId) {
        return Promise.reject('No request id provided.');
      }

      const { data } = await client.get(
        `/apps/${applicationID}/gateways/${gatewayId}/discovery_request/${requestId}`,
        { params }
      );

      return data;
    },
    {
      refetchInterval(request) {
        if (request && request.status === 'pending') {
          // Poll every two seconds for as long as discovery is pending
          return 2000;
        }

        return false;
      },
      ...options,
      enabled:
        enabled !== undefined
          ? Boolean(requestId) && Boolean(gatewayId) && enabled
          : Boolean(requestId) && Boolean(gatewayId),
    }
  );
}
